module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYBAMAAAASWSDLAAAAFVBMVEUAAABicZlicZlicZlicZlicZlicZlhqzbKAAAABnRSTlMA8OdJO+SJpFFbAAAARElEQVQY02MgCxilQYEykKMG4yQBOWkOEBUsaSAOTD2EIwgkBRkFwBwYQJdB6MHkgNUwYBqAkMHQg3AOmkMRXggmKwQAY6gf7xUre5kAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_finance.png
// module id = KviO
// module chunks = 9